import { useQuery } from "@tanstack/react-query";
import { getTask } from "../api/todo.js";
import { withQueryParams } from "../helpers/withQueryParams.js";
import { useAxiosProvider } from "../providers/AxiosProvider.js";
import "../helpers/parseArrayQueryParam.js";
import "react/jsx-runtime";
import "react";
import "axios";
const useTodo = ({ selectedTodo, showModal }) => {
  const axios = useAxiosProvider();
  const enabled = !!selectedTodo && showModal;
  const { data: todoDetails, ...query } = useQuery({
    queryKey: ["appointment-details", { referenceId: (selectedTodo == null ? void 0 : selectedTodo.referenceId) ?? "" }],
    queryFn: withQueryParams(getTask(axios)),
    enabled
  });
  return { todoDetails: enabled ? todoDetails : void 0, ...query };
};
export {
  useTodo
};
